import React from "react";
import './Other.css';
import {useTranslation} from "react-i18next";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import SurveyTable from "../../components/SurveyTable";

const Other = () => {

    const {t} = useTranslation();

    return (
        <>

        <HelmetProvider>
            <Helmet>
                <title>{t('root.meta.other.title')}</title>
                <meta property="description" content={t('root.meta.other.description')}/>
                <meta property="og:site_name" content={t('root.meta.other.title')}/>
                <meta property="og:title" content={t('root.meta.other.title')}/>
                <meta property="og:description" content={t('root.meta.other.description')}/>
            </Helmet>
        </HelmetProvider>
            <div className={"px-2 sm:px-0"}>
                <div className={"container mx-auto mt-4 mb-4 md:mt-6 md:mb-6"}>
                    <div className={"grid grid-cols-1 pt-4 pb-4"}>
                        <p className={"text-4xl text-[#163578] uppercase"}>{t('otherSector.mainTitle')}</p>
                    </div>
                </div>

                <img
                    src="/images/finance-banner.webp"
                    className={"w-full hidden sm:block"}
                    alt="finance-banner"/>

                <div id="survey" className={"container mx-auto relative bottom-0 sm:bottom-5 md:bottom-10 lg:bottom-28"}>
                    {/*<p className={"text-2xl font-bold border-b-2 border-gray-300 pb-8 mb-6"}>{t('surveyTable.mainTitle')}</p>*/}
                    <SurveyTable parentId={40}/></div>
            </div>
        </>
    );
};
export default Other;